import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import PrimaryButton from '~/components/buttons/PrimaryButton';
import PromptModal from '~/components/modals/PromptModal';
const CountySelectionModal = ({ counties, setCounty }) => {
    const [selectedCounty, setSelectedCounty] = useState();
    const updateCounty = (e) => {
        setSelectedCounty(e.target.value);
    };
    const selectCounty = () => {
        setCounty(selectedCounty);
    };
    return (_jsx(PromptModal, { title: "Select a County", children: _jsx("div", { className: "mt-8 flex justify-center gap-4", children: _jsxs("div", { className: "flex flex-col", children: [_jsxs("select", { className: "mb-14 w-[300px] rounded-md border-gray-200", onChange: updateCounty, children: [_jsx("option", { value: "", children: "Select a county" }), counties.map((county) => (_jsx("option", { value: county.value, children: county.label }, county.code)))] }), _jsx(PrimaryButton, { disabled: !selectedCounty, onClick: selectCounty, text: "Continue" })] }) }) }));
};
export default CountySelectionModal;
